<!-- 全部商品分类页签切换!-->
<template>
  <div id="bars">
    <div class="content">
      <ul>
        <li>
          <!-- 分类导航栏 -->
          <Nav :flexible="flexible"></Nav>
        </li>
        <li class="li" v-for="(showpage, i) in showMainPage" :key="i">
          <div
            :class="{ tabselect: i == clickmain }"
            @click="show(showpage.rank, showpage.source, i)"
          >
            <a href="javascript:void(0)">{{ showpage.name }}</a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Nav from "./Nav.vue";
export default {
  components: {
    Nav: Nav,
  },
  data() {
    return {
      constant: this.$store.state.malMainPageConfig.constant,
      showMainPage: this.$store.state.malMainPageConfig.showMainPage.showMainPage,
      clickmain: 0,
      flexible:!this.$store.state.malMainPageConfig.nav.isShowAlways
    };
  },
  methods: {
    
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 90) {
        this.flexible = true;
      } else {
        this.flexible = !this.$store.state.malMainPageConfig.nav.isShowAlways;
      }
    },
    //页签切换
    show(rank, source, index) {
      // 修改样式下标
      this.clickmain = index;
      //从缓存中取值
      var cacheMap = this.$store.state.cacheMap;
      if(cacheMap.has(rank)){
        this.$store.commit({
          type: "updateMalMainPageConfig",
          malMainPageConfig: cacheMap.get(rank),
        });
        return;
      }
      //获取商城数据
      let malMainPageConfig = JSON.parse(JSON.stringify(this.$store.state.malMainPageConfig));
      // 获取商品分类导航栏 传入商品分类
      this.$api.mainpageApi.getNavJo(source).then((navresponse) => {
        let navJo = navresponse.data.data;
        malMainPageConfig.nav = navJo;
        this.$store.commit({
          type: "updateMalMainPageConfig",
          malMainPageConfig: malMainPageConfig,
        });
        this.$store.commit({
          type:"updateCacheMap",
          key:rank,
          value:malMainPageConfig
        });
        
      });

      // 获取轮播图 传入首页方案顺序
      let swiper = this.$store.state.malMainPageConfig.malSwiper.swiperSlide;
      this.$api.mainpageApi.loadMalSwiper(rank).then((response) => {
        this.swiper = response.data.data;
        malMainPageConfig.malSwiper = this.swiper;
        this.$store.commit({
          type: "updateMalMainPageConfig",
          malMainPageConfig: malMainPageConfig,
        });
        this.$store.commit({
          type:"updateCacheMap",
          key:rank,
          value:malMainPageConfig
        });
        
      });

      // 获取促销方案传入首页方案顺序 传入首页方案顺序
      let cardBody = this.$store.state.malMainPageConfig.cardBody;
      this.$api.mainpageApi.loadCardBody(rank).then((response) => {
        this.cardBody = response.data.data;
        malMainPageConfig.cardBody = this.cardBody;
        this.$store.commit({
          type: "updateMalMainPageConfig",
          malMainPageConfig: malMainPageConfig,
        });
        this.$store.commit({
          type:"updateCacheMap",
          key:rank,
          value:malMainPageConfig
        });
        
      });

      // 获取品质店铺传入首页方案顺序 传入首页方案顺序
      let storeBody = this.$store.state.malMainPageConfig.storeBody;
      this.$api.mainpageApi.loadStoreBody(rank).then((response) => {
        this.storeBody = response.data.data;
        malMainPageConfig.storeBody = this.storeBody;
        this.$store.commit({
          type: "updateMalMainPageConfig",
          malMainPageConfig: malMainPageConfig,
        });
        this.$store.commit({
          type:"updateCacheMap",
          key:rank,
          value:malMainPageConfig
        });
        
      });

      //获取分类商品传入首页方案顺序 传入首页方案顺序
      let categoryGoodsShow = this.$store.state.malMainPageConfig.categoryGoodsShow;
      this.$api.mainpageApi.loadJdProducts(rank).then((response) => {
        this.categoryGoodsShow = response.data.data;
        malMainPageConfig.categoryGoodsShow = this.categoryGoodsShow;
        this.$store.commit({
          type: "updateMalMainPageConfig",
          malMainPageConfig: malMainPageConfig,
        });
        this.$store.commit({
          type:"updateCacheMap",
          key:rank,
          value:malMainPageConfig
        });
        
      });

      // 获取企业信息 友情链接 传入首页方案顺序
      let bottombox = this.$store.state.malMainPageConfig.bottombox;
      this.$api.mainpageApi.loadBottombox(rank).then((response) => {
        this.bottombox = response.data.data;
        malMainPageConfig.bottombox = this.bottombox;
        this.$store.commit({
          type: "updateMalMainPageConfig",
          malMainPageConfig: malMainPageConfig,
        });
        this.$store.commit({
          type:"updateCacheMap",
          key:rank,
          value:malMainPageConfig
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
#bars {
  background-color: #ffffff;
  margin-top: -16px;
}
#bars .content {
  width: 1200px;
  height: 48px;
  margin: 0 auto;
}
* {
  padding: 0;
}
div {
  display: block;
  background: #ffffff;
}
.content > ul > li {
  float: left;
  height: 48px;
  line-height: 48px;
  padding: 0 20px 0 0;
  font-size: 16px;
  // 苹方-简 中黑体
  font-family: PingFangSC-Medium, sans-serif;
}
li {
  list-style: none;
}
a {
  text-decoration: none;
  color: #000;
}
.c_left a {
  padding: 0 2px;
  cursor: pointer;
}

.c_left ul {
  padding: 15px 0;
}
.c_left li {
  width: 200px;
  height: 20px;
  padding: 5px 0 5px 10px;
  position: relative;
}

.c_left li p {
  float: left;
  width: 180px;
  height: 20px;
  line-height: 20px;
  overflow: hidden;
  position: absolute;
}
/*轮播图左边第一个二级菜单*/
.c_left .box .bx_a .case1 a {
  padding: 3px 10px;
  margin-right: 7px;
  background-color: #6e6568;
}
.c_left .box .bx_a .case1 a:hover {
  background-color: #5c5251;
}
.c_left .box .bx_a .case2 h5 {
  float: left;
  width: 70px;
  height: 41px;
  line-height: 41px;
  text-align: right;
}
.c_left .box .bx_a .case2 a {
  float: left;
  height: 30px;
  line-height: 30px;
  padding: 0 7px 0 0;
}
.c_left .box .bx_a .case2 a:hover {
  color: #c94e4a;
}
/*轮播图左边第一个二级菜单END*/

.c_left li:hover {
  background-color: #999395;
}
.c_left p a:hover {
  color: #c81623;
}

.c_left .box .bx_a .case1 a {
  padding: 3px 10px;
  margin-right: 7px;
  background-color: #6e6568;
}
.tabselect {
  height: 45px;
  color: #2386ee;
  border-bottom: 3px #2386ee solid;
}
.tabselect a {
  color: #2386ee;
  font-size: 16px;
  // 苹方-简 中黑体
  font-family: PingFangSC-Medium, sans-serif;
}
</style>
